import { createFileRoute } from '@tanstack/react-router';
import { BotFiltering } from '@/components/bot-filtering';
import { FirstPartyProxy } from '@/components/first-party-proxy';
import { UrlPrivacySettings } from '@/components/url-privacy-settings';
import { PageContent } from '@/components/page-content';
import { useProjects } from '@/hooks/use-projects';

export const Route = createFileRoute(
  '/_auth/_side-layout/project-settings/filters',
)({
  component: FiltersSettings,
});

function FiltersSettings() {
  const { projectId } = useProjects();

  return (
    <PageContent>
      <BotFiltering />
      <FirstPartyProxy />
      {/* key={projectId} resets the allowlist/mode draft when the active
          project changes (global state, not a route param). */}
      <UrlPrivacySettings key={projectId} />
    </PageContent>
  );
}
